import { render, staticRenderFns } from "./connect.vue?vue&type=template&id=50be826c&scoped=true&"
import script from "./connect.vue?vue&type=script&lang=js&"
export * from "./connect.vue?vue&type=script&lang=js&"
import style0 from "./connect.vue?vue&type=style&index=0&id=50be826c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be826c",
  null
  
)

export default component.exports